import React, { useEffect, useRef, useState } from 'react';
import MediaQuery from '../common/MediaQuery';
import SectionHeader from '../common/SectionHeader';
import Quote from './testimony/Quote';
import PageControl from './testimony/PageControl';

import { ReactComponent as BackgroundImage } from '../assets/logo_infinity.svg';

import TayasuiImage from '../assets/home/tayasui.jpeg';
import JBKImage from '../assets/home/jbk.jpeg';
import JetItNowImage from '../assets/home/jetitnow.jpeg';
import { useI18n } from '../i18n/I18nContext';

function Testimony() {
  const { t } = useI18n();
  const [page, setPage] = useState(0);
  const scrollRef = useRef(null);

  useEffect(() => {
    const container = scrollRef.current;
    const updatePage = () => {
      setPage(Math.round(container.scrollLeft / container.clientWidth));
    };
    container.addEventListener('scroll', updatePage, { passive: true });
    const observer = new ResizeObserver(updatePage);
    observer.observe(container);
    return () => {
      container.removeEventListener('scroll', updatePage);
      observer.disconnect();
    };
  }, []);

  const selectPage = index => {
    const container = scrollRef.current;
    container.scrollTo({
      left: container.clientWidth * index,
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
    });
  };

  const allQuotes = [
    <Quote
      key="TayasuiImage"
      image={TayasuiImage}
      title="Tayasui"
      description={t("home.testimonials.tayasui.description")}
      message={t("home.testimonials.tayasui.message")}
      url="https://www.tayasui.com/"
      />,
    <Quote
      key="JBKImage"
      image={JBKImage}
      title="JBK Corporation"
      description={t("home.testimonials.jbk.description")}
      message={t("home.testimonials.jbk.message")}
      url="https://www.jbk-communication.fr/"
      />,
    <Quote
      key="JetItNowImage"
      image={JetItNowImage}
      title="JetItNow"
      description={t("home.testimonials.jetitnow.description")}
      message={t("home.testimonials.jetitnow.message")}
      url="https://www.jetitnow.com/"
      />
  ];

  const smallLength = allQuotes.length;
  const length = Math.round(allQuotes.length / 2);

  return (
    <section id="references" className="relative overflow-x-clip py-[5rem] px-10">
      <BackgroundImage aria-hidden="true" className="absolute text-primary-300 left-[-445px] w-[609px] h-[314px] bottom-0 transform translate-y-1/2 z-10" />
      <div className="relative max-w-[1200px] mx-auto z-20">
        <SectionHeader title={t("home.testimonials.title")} subtitle={t("home.testimonials.subtitle")} />
        <div ref={scrollRef} className="flex flex-nowrap w-full py-[4.375rem] overflow-x-scroll">
          {allQuotes}
        </div>
        <MediaQuery 
          medium={<PageControl
            selected={page}
            setSelected={selectPage}
            length={smallLength}/>}
          large={<PageControl
            selected={page}
            setSelected={selectPage}
            length={length}/>}
        />
      </div>
    </section>
  );
}

export default Testimony;
